<template>
  <div>Loading Data...</div>
</template>

<script>
export default {
  name: 'default-loading-spinner',
};
</script>
